import { FileAttachment } from "features/attachments";

import useWorkspaceAttachmentUrl from "common/datahooks/useWorkspaceAttachmentUrl";

type Attachment =
  | {
      id: string;
      name: string;
      byteSize: number;
      mimeType: string;
      file?: File;
    }
  | { file: File; errorMessage?: string };

export default function TemplateAttachment({
  attachment,
  onRemove,
}: {
  attachment: Attachment;
  onRemove?: () => void;
}) {
  const isUploaded = "id" in attachment;

  const { attachmentUrl } = useWorkspaceAttachmentUrl(
    isUploaded && attachment.id,
  );

  const props = isUploaded
    ? {
        fileData: {
          name: attachment.name,
          byteSize: attachment.byteSize,
          mimeType: attachment.mimeType,
          url: attachment.file
            ? URL.createObjectURL(attachment.file)
            : attachmentUrl,
        },
      }
    : { file: attachment.file, errorMessage: attachment.errorMessage };

  return <FileAttachment {...props} onRemove={onRemove} />;
}
